import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from './pages/Home/Home';
import { SpeechToTextLive } from './pages/SpeechToTextLive/SpeechToTextLive';
import { ChatGPT } from './pages/ChatGPT/ChatGPT';
import { SpeechToTextUpload } from './pages/SpeechToTextUpload/SpeechToTextUpload';
import { OCRPDF } from './pages/OCRPDF/OCRPDF';
import { Presentation } from './pages/Presentation/Presentation';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sttrt" element={<SpeechToTextLive />} />
        <Route path="/gpt" element={<ChatGPT />} />
        <Route path="/sttf" element={<SpeechToTextUpload />} />
        <Route path="/ocrpdf" element={<OCRPDF />} />
        <Route path="/presentation" element={<Presentation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
